module.exports = __webpack_public_path__ + "static/img/customer6-3.54bb063.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/phoneCasePage/customer6-3.png
// module id = wyDY
// module chunks = 0